import React from 'react';
import { useChatStore } from '../lib/store';

interface NavbarProps {
  variant?: 'website' | 'chat';
}

export function Navbar({ variant = 'website' }: NavbarProps) {
  const baseClasses = "sticky top-0 z-40 w-full p-6 bg-black";
  const containerClasses = "max-w-7xl mx-auto flex justify-between items-center";
  const { personalityMode, setPersonalityMode } = useChatStore();

  const renderLinks = () => {
    return (
      <div className="hidden md:flex space-x-6">
        <a href="/lexievault" className="text-lg font-bold text-purple-300 hover:text-white transition-colors">LexieVault</a>
        <a href="https://chatroom.lexiecrypto.com" className="text-lg font-bold text-purple-300 hover:text-white transition-colors">LexieChat</a>
        <a href="#features" className="text-lg font-bold text-purple-300 hover:text-white transition-colors">Features</a>
        <a href="#security" className="text-lg font-bold text-purple-300 hover:text-white transition-colors">Security</a>
        <a href="#beta" className="text-lg font-bold text-purple-300 hover:text-white transition-colors">Beta</a>
      </div>
    );
  };

  return (
    <nav className={baseClasses}>
      <div className={containerClasses}>
        <a href="https://www.lexiecrypto.com" className="text-4xl font-bold text-purple-300 hover:text-white transition-colors">
          LEXIEAI
        </a>
        <div className="flex items-center gap-4">
          {renderLinks()}
          {/* Degen toggle moved to TerminalWindow header */}
        </div>
      </div>
    </nav>
  );
}
